import classNames from 'classnames';
import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import { useGetKeywordsForSelectQuery } from '@/app/KeywordTracker/api/keywordsApi';
import { FaDesktop, FaMobileScreenButton } from 'react-icons/fa6';
import { Form } from 'react-bootstrap';
import Select from 'react-select';
import useDomain from '@/hooks/useDomain';
import type { KeywordsForSelectProps } from './types';
import type { OptionProps } from 'react-select';
import type { SelectOption } from './types';

const KeywordsForSelect = ({
  setFieldValue,
  values,
  footer,
  label,
  placeholder
}: KeywordsForSelectProps) => {
  const { domain_slug } = useDomain();

  const { data: keywords, isFetching: isLoadingKeywords } =
    useGetKeywordsForSelectQuery(domain_slug);
  return (
    <Form.Group className="my-3">
      <Form.Label>{label}</Form.Label>
      {!isLoadingKeywords ? (
        <Select
          classNamePrefix="react-select"
          menuShouldScrollIntoView={true}
          closeMenuOnSelect={false}
          placeholder={placeholder}
          styles={{
            menu: (baseStyles, state) => ({
              position: 'absolute',
              // overflow: 'auto',
              zIndex: 9999,
              width: '100%'
            }),
            control: (baseStyles, state) => ({
              ...baseStyles,
              direction: 'rtl !important',
              paddingLeft: '10px',
              paddingRight: '10px',
              color: 'var(--falcon-emphasise) !important',
              boxShadow: 'none !important',
              borderRadius: '5px 5px 5px 5px !important',
              width: '100% !important',
              cursor: 'pointer'
            }),
            input: (baseStyles, state) => ({
              ...baseStyles,
              direction: 'ltr !important',
              color: 'var(--falcon-emphasise) !important',
              boxShadow: 'none !important'
            })
          }}
          components={{ Option: OptionLayout }}
          onChange={e => {
            setFieldValue('keyword_ids', e);
          }}
          isMulti
          value={values.keyword_ids}
          isSearchable={true}
          noOptionsMessage={() => 'یافت نشد.'}
          options={keywords?.data || []}
        />
      ) : (
        <Select
          classNamePrefix="react-select"
          menuShouldScrollIntoView={true}
          closeMenuOnSelect={false}
          placeholder="انتخاب کلمات کلیدی برای این دسته"
          styles={{
            menu: (baseStyles, state) => ({
              position: 'absolute',
              // overflow: 'auto',
              zIndex: 9999,
              width: '100%'
            }),
            control: (baseStyles, state) => ({
              ...baseStyles,
              direction: 'rtl !important',
              paddingLeft: '10px',
              paddingRight: '10px',
              color: 'var(--falcon-emphasise) !important',
              boxShadow: 'none !important',
              borderRadius: '5px 5px 5px 5px !important',
              width: '100% !important',
              cursor: 'pointer'
            }),
            input: (baseStyles, state) => ({
              ...baseStyles,
              direction: 'ltr !important',
              color: 'var(--falcon-emphasise) !important',
              boxShadow: 'none !important'
            })
          }}
          components={{ Option: OptionLayout }}
          onChange={e => {
            setFieldValue('keyword_ids', e);
          }}
          isMulti
          value={values.keyword_ids}
          isSearchable={true}
          noOptionsMessage={() => 'یافت نشد'}
          options={[]}
        />
      )}
      {footer}
    </Form.Group>
  );
};

export default KeywordsForSelect;

const OptionLayout = (props: OptionProps<SelectOption>) => {
  const { innerProps, innerRef } = props;
  return (
    <>
      <style>{`
            .customized-searchbox-option:hover{
              background-color:var(--falcon-gray-link-hover-300) !important;
            }
            .customized-searchbox-option{
              background-color:var(--falcon-tertiary-bg) !important;
            }
            `}</style>
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          backgroundColor: props.isSelected
            ? 'var(--falcon-gray-link-hover-100)'
            : 'var(--falcon-dropdown-bg-global)'
        }}
        className={classNames(
          'p-2 cursor-pointer border border-1 customized-searchbox-option',
          {}
        )}
      >
        <div className="fs-0 text-900">
          {props.data.label}
          {props.data.device_type === 1 ? (
            <FaDesktop className="mx-1" title="desktop" />
          ) : (
            <FaMobileScreenButton className="mx-1" title="mobile" />
          )}{' '}
          <span className="border border-400 border-1 fs--2 rounded-2 py-0 px-1">
            {props?.data?.location}
          </span>
        </div>
        <div className="text-secondary fs--2"></div>
      </div>
    </>
  );
};
